import ActionsTypes from '../../constants/ActionsTypes'

const companiesManager = {
	getCompanies: (filters = {}, queryParams = { page: '0', size: '250', sort: 'labelCommercial', nameDir: 'asc' }) => ({
		type: ActionsTypes.GET_COMPANIES,
		payload: { filters, queryParams },
	}),
	getCompaniesSuccess: (data) => ({
		type: ActionsTypes.GET_COMPANIES_SUCCESS,
		payload: {
			data,
		},
	}),
	getCompaniesFailure: (error) => ({
		type: ActionsTypes.GET_COMPANIES_FAILURE,
		payload: {
			error,
		},
	}),
	setCompanyId: (companyId) => ({
		type: ActionsTypes.SET_USER_COMPANY_ID,
		payload: {
			companyId,
		},
	}),
	setStateCompany: (id, mode) => ({
		type: ActionsTypes.SET_STATE_COMPANY,
		payload: {
			id,
			mode,
		},
	}),
	setStateCompanySuccess: (idCompany, data) => ({
		type: ActionsTypes.SET_STATE_COMPANY_SUCCESS,
		payload: {
			idCompany,
			data,
		},
	}),
	setStateCompanyFailure: (error) => ({
		type: ActionsTypes.SET_STATE_COMPANY_FAILURE,
		payload: {
			error,
		},
	}),
	getAvailableListsCompany: () => ({
		type: ActionsTypes.GET_COMPANY_AVAILABLE_LISTS,
	}),
	getAvailableListsCompanySuccess: (data) => ({
		type: ActionsTypes.GET_COMPANY_AVAILABLE_LISTS_SUCCESS,
		payload: {
			data,
		},
	}),
	getAvailableListsCompanyFailure: (error) => ({
		type: ActionsTypes.GET_COMPANY_AVAILABLE_LISTS_FAILURE,
		payload: {
			error,
		},
	}),
	createCompany: (data, noRedirect = false) => ({
		type: ActionsTypes.CREATE_COMPANY,
		payload: {
			data,
			noRedirect,
		},
	}),
	createCompanySuccess: (data) => ({
		type: ActionsTypes.CREATE_COMPANY_SUCCESS,
		payload: {
			data,
		},
	}),
	createCompanyFailure: (error) => ({
		type: ActionsTypes.CREATE_COMPANY_FAILURE,
		payload: {
			error,
		},
	}),
	getDataForUpdate: (id) => ({
		type: ActionsTypes.GET_COMPANY_DATA,
		payload: { id },
	}),
	getDataForUpdateSuccess: (data) => ({
		type: ActionsTypes.GET_COMPANY_DATA_SUCCESS,
		payload: {
			data,
		},
	}),
	getDataForUpdateFailure: (error) => ({
		type: ActionsTypes.GET_COMPANY_DATA_FAILURE,
		payload: {
			error,
		},
	}),
	updateCompany: (id, data) => ({
		type: ActionsTypes.UPDATE_COMPANY,
		payload: {
			id,
			data,
		},
	}),
	updateCompanySuccess: (data) => ({
		type: ActionsTypes.UPDATE_COMPANY_SUCCESS,
		payload: {
			data,
		},
	}),
	updateCompanyFailure: (error) => ({
		type: ActionsTypes.UPDATE_COMPANY_FAILURE,
		payload: {
			error,
		},
	}),
	resetDataCompany: () => ({
		type: ActionsTypes.RESET_DATA_COMPANY,
	}),
	checkDisablingGroupDistribution: (idCompany, idCompanyTyped, isDistributorGroup = false) => ({
		type: ActionsTypes.CHECK_DISTRIBUTION_GROUP_DISABLING,
		payload: {
			idCompany,
			idCompanyTyped,
			isDistributorGroup,
		},
	}),
	checkDisablingGroupDistributionSuccess: (id, value) => ({
		type: ActionsTypes.CHECK_DISTRIBUTION_GROUP_DISABLING_SUCCESS,
		payload: {
			id,
			value,
		},
	}),
	checkDisablingGroupDistributionFailure: (id, value) => ({
		type: ActionsTypes.CHECK_DISTRIBUTION_GROUP_DISABLING_FAILURE,
		payload: {
			id,
			value,
		},
	}),
	checkDisablingDistribution: (idCompany, idCompanyTyped, isDistributorGroup = true) => ({
		type: ActionsTypes.CHECK_DISTRIBUTION_DISABLING,
		payload: {
			idCompany,
			idCompanyTyped,
			isDistributorGroup,
		},
	}),
	checkDisablingDistributionSuccess: (id, value) => ({
		type: ActionsTypes.CHECK_DISTRIBUTION_DISABLING_SUCCESS,
		payload: {
			id,
			value,
		},
	}),
	checkDisablingDistributionFailure: (id, value) => ({
		type: ActionsTypes.CHECK_DISTRIBUTION_DISABLING_FAILURE,
		payload: {
			id,
			value,
		},
	}),

	deleteTechSupport: (idCompany, idCompanyTyped) => ({
		type: ActionsTypes.DELETE_TECH_SUPPORT,
		payload: {
			idCompany,
			idCompanyTyped,
		},
	}),
	deleteTechSupportSuccess: (id, value) => ({
		type: ActionsTypes.DELETE_TECH_SUPPORT_SUCCESS,
		payload: {
			id,
			value,
		},
	}),
	deleteTechSupportFailure: (id, value) => ({
		type: ActionsTypes.DELETE_TECH_SUPPORT_FAILURE,
		payload: {
			id,
			value,
		},
	}),
	putSMSRefill: (id, value) => ({
		type: ActionsTypes.PUT_SMS_REFILL,
		payload: {
			id,
			value,
		},
	}),
	putSMSRefillSuccess: (data) => ({
		type: ActionsTypes.PUT_SMS_REFILL_SUCCESS,
		payload: {
			data,
		},
	}),
	putSMSRefillFailure: (error) => ({
		type: ActionsTypes.PUT_SMS_REFILL_FAILURE,
		payload: {
			error,
		},
	}),
	putDeleteCompanySubGroupPartnership: (idCompany, idCompanySubgroupPartner) => ({
		type: ActionsTypes.PUT_DELETE_COMPANY_SUBGROUP_PARTNERSHIP,
		payload: {
			idCompany,
			idCompanySubgroupPartner,
		},
	}),
	putDeleteCompanySubGroupPartnershipSuccess: (data) => ({
		type: ActionsTypes.PUT_DELETE_COMPANY_SUBGROUP_PARTNERSHIP_SUCCESS,
		payload: {
			data,
		},
	}),
	putDeleteCompanySubGroupPartnershipFailure: (error) => ({
		type: ActionsTypes.PUT_DELETE_COMPANY_SUBGROUP_PARTNERSHIP_FAILURE,
		payload: {
			error,
		},
	}),
	putDeleteCompanySubGroupLink: (idCompany, idCompanySubgroupLink) => ({
		type: ActionsTypes.PUT_DELETE_COMPANY_SUBGROUP_LINK,
		payload: {
			idCompany,
			idCompanySubgroupLink,
		},
	}),
	putDeleteCompanySubGroupLinkSuccess: (data) => ({
		type: ActionsTypes.PUT_DELETE_COMPANY_SUBGROUP_LINK_SUCCESS,
		payload: {
			data,
		},
	}),
	putDeleteCompanySubGroupLinkFailure: (error) => ({
		type: ActionsTypes.PUT_DELETE_COMPANY_SUBGROUP_LINK_FAILURE,
		payload: {
			error,
		},
	}),
	setOwner: (labelToDisplay) => ({
		type: ActionsTypes.SET_OWNER,
		payload: {
			labelToDisplay,
		},
	}),
}

export default companiesManager
